import { render } from "./EmailPanelHandler.vue?vue&type=template&id=67afe8e0"
import script from "./EmailPanelHandler.vue?vue&type=script&lang=js"
export * from "./EmailPanelHandler.vue?vue&type=script&lang=js"

import "./EmailPanelHandler.vue?vue&type=style&index=0&id=67afe8e0&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__